import { render, staticRenderFns } from "./ServiceForm.vue?vue&type=template&id=2f3b01db&scoped=true"
import script from "./ServiceForm.vue?vue&type=script&lang=js"
export * from "./ServiceForm.vue?vue&type=script&lang=js"
import style0 from "./ServiceForm.vue?vue&type=style&index=0&id=2f3b01db&prod&lang=css"
import style1 from "./ServiceForm.vue?vue&type=style&index=1&id=2f3b01db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3b01db",
  null
  
)

export default component.exports